import { createTheme, ThemeProvider } from "@mui/material";

export const theme = createTheme({
  direction: "rtl",
  palette: {
    primary: {
      main: "#5ebb46",
      light: "#66e547",
      dark: "#50ae38",
      contrastText: "#fff",
      appbarItem: "#168AFB",
    },
    secondary: {
      light: "#fafafa",
      main: "#F8F8FA",
      dark: "gray",
      contrastText: "#000000",
    },
    shadow: {
      main: "rgb(194, 194, 194)",
    },
  },
  typography: {
    fontFamily: "IRANSans",
    fontSize: 16,
  },
});

export const MuiThemeProivider = (props) => {
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};
